import React from 'react'

import LinkedJiraServerIssues from './LinkedJiraServerIssues'
import LinkJiraServerIssue from './LinkJiraServerIssue'
import PaddedWrapper from '../shared/InAppCard/PaddedWrapper'

export default function JiraServerInAppCard() {
  return (
    <PaddedWrapper>
      <LinkedJiraServerIssues />
      <LinkJiraServerIssue />
    </PaddedWrapper>
  )
}
